type AwardSection = {
  id: string
  titleVi: string
  subtitleVi?: string
  titleEn: string
  subtitleEn?: string
}

type AwardCriteria = {
  vi: string
  en?: string
}

type AwardCategory = {
  id: string
  sectionId: string
  nameVi: string
  nameEn: string
  descriptionVi: string
  descriptionEn: string
  criteria: AwardCriteria[]
}

export const awardSections: AwardSection[] = [
  {
    id: 'professional',
    titleVi: 'I. NHÓM GIẢI THƯỞNG CHUYÊN MÔN',
    subtitleVi: '(Vận động viên & Thể thao)',
    titleEn: 'I. PROFESSIONAL AWARDS',
    subtitleEn: '(Athletes & Competition)',
  },
  {
    id: 'community',
    titleVi: 'II. NHÓM GIẢI THƯỞNG CỘNG ĐỒNG',
    titleEn: 'II. COMMUNITY AWARDS',
  },
  {
    id: 'brand',
    titleVi: 'III. NHÓM GIẢI THƯỞNG THƯƠNG HIỆU & DOANH NGHIỆP',
    titleEn: 'III. BRAND & CORPORATE AWARDS',
  },
]

export const awardCategories: AwardCategory[] = [
  {
    id: 'mens-player-year',
    sectionId: 'professional',
    nameVi: 'Nam Vận Động Viên Pickleball Xuất Sắc Nhất Của Năm',
    nameEn: 'Men’s Pickleball Player of the Year',
    descriptionVi:
      'Giải thưởng nhằm tôn vinh vận động viên nam pickleball có thành tích thi đấu nổi bật nhất trong năm 2025, thể hiện phong độ ổn định, bản lĩnh thi đấu và tinh thần thể thao chuyên nghiệp, đồng thời đóng góp tích cực cho sự phát triển và hình ảnh của pickleball Việt Nam.',
    descriptionEn:
      'This award honors the male pickleball athlete with the most outstanding competitive achievements in 2025, demonstrating consistent performance, competitive excellence, and professional sportsmanship, while making significant contributions to the development and image of pickleball in Vietnam.',
    criteria: [
      { vi: 'Thành tích thi đấu chính thức', en: 'Official tournament results' },
      { vi: 'Thứ hạng & danh hiệu', en: 'Rankings and titles achieved' },
      { vi: 'Phong độ ổn định', en: 'Performance consistency' },
      { vi: 'Tinh thần thể thao & hình ảnh', en: 'Sportsmanship and positive image' },
      { vi: 'Truyền cảm hứng cộng đồng', en: 'Inspiration to the pickleball community' },
    ],
  },
  {
    id: 'womens-player-year',
    sectionId: 'professional',
    nameVi: 'Nữ Vận Động Viên Pickleball Xuất Sắc Nhất Của Năm',
    nameEn: 'Women’s Pickleball Player of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh vận động viên nữ pickleball tiêu biểu trong năm 2025, có thành tích thi đấu nổi bật và đóng vai trò quan trọng trong việc lan tỏa hình ảnh, tinh thần và phong trào pickleball nữ tại Việt Nam.',
    descriptionEn:
      'This award recognizes an outstanding female pickleball athlete in 2025, distinguished by exceptional competitive performance and a significant role in promoting women’s pickleball in Vietnam.',
    criteria: [
      { vi: 'Thành tích thi đấu', en: 'Competitive achievements' },
      { vi: 'Đóng góp phong trào', en: 'Contribution to tournaments and community' },
      { vi: 'Tinh thần thi đấu & chuyên nghiệp', en: 'Professional attitude and sportsmanship' },
      { vi: 'Hình ảnh & sức ảnh hưởng', en: 'Positive image and community influence' },
    ],
  },
  {
    id: 'mens-doubles-year',
    sectionId: 'professional',
    nameVi: 'Đôi VĐV Nam Xuất Sắc Nhất Của Năm',
    nameEn: 'Men’s Doubles Team of the Year',
    descriptionVi:
      'Giải thưởng tôn vinh đôi vận động viên nam pickleball có thành tích thi đấu xuất sắc trong năm 2025, thể hiện sự gắn kết, phối hợp chiến thuật hiệu quả và tinh thần đồng đội nổi bật, đồng thời đóng góp tích cực cho phong trào pickleball địa phương và quốc gia.',
    descriptionEn:
      'This award honors the men’s doubles team with outstanding competitive results in 2025, demonstrating strong teamwork, effective tactics, and meaningful contributions to pickleball development at both local and national levels.',
    criteria: [
      { vi: 'Kết quả thi đấu', en: 'Official match results' },
      { vi: 'Gắn kết & chiến thuật', en: 'Teamwork and tactical effectiveness' },
      { vi: 'Đóng góp phong trào', en: 'Contribution to pickleball development' },
    ],
  },
  {
    id: 'womens-doubles-year',
    sectionId: 'professional',
    nameVi: 'Đôi VĐV Nữ Xuất Sắc Nhất Của Năm',
    nameEn: 'Women’s Doubles Team of the Year',
    descriptionVi:
      'Giải thưởng tôn vinh đôi vận động viên nữ pickleball có thành tích thi đấu nổi bật trong năm 2025, thể hiện tinh thần đoàn kết, phong độ ổn định và hình ảnh tích cực, góp phần lan tỏa phong trào pickleball nữ tại Việt Nam.',
    descriptionEn:
      'This award recognizes a women’s doubles team with outstanding performance in 2025, showcasing unity, consistent form, and a positive role in promoting women’s pickleball in Vietnam.',
    criteria: [
      { vi: 'Thành tích bộ đôi', en: 'Team achievements' },
      { vi: 'Phát triển & ổn định phong độ', en: 'Development and consistency' },
      { vi: 'Hình ảnh cộng đồng', en: 'Positive community image' },
    ],
  },
  {
    id: 'mixed-doubles-year',
    sectionId: 'professional',
    nameVi: 'Đôi VĐV Nam – Nữ Xuất Sắc Nhất Của Năm',
    nameEn: 'Mixed Doubles Team of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh đôi vận động viên nam – nữ có thành tích nổi bật, thể hiện sự phối hợp ăn ý, chiến thuật hiệu quả và tinh thần đồng đội cao, đại diện cho sự cân bằng và phát triển toàn diện của pickleball Việt Nam.',
    descriptionEn:
      'This award honors a mixed doubles team with outstanding results, demonstrating strong coordination, tactical efficiency, and representing balanced and inclusive development of pickleball in Vietnam.',
    criteria: [
      { vi: 'Thành tích thi đấu', en: 'Competitive results' },
      { vi: 'Phối hợp & chiến thuật', en: 'Coordination and tactics' },
      { vi: 'Giá trị hình ảnh & lan tỏa', en: 'Representation and positive influence' },
    ],
  },
  {
    id: 'mens-u18-prospect',
    sectionId: 'professional',
    nameVi: 'VĐV Nam Trẻ Triển Vọng Của Năm (U18)',
    nameEn: 'Men’s Young Prospect of the Year',
    descriptionVi:
      'Giải thưởng dành cho vận động viên nam dưới 18 tuổi có bước tiến vượt trội trong năm 2025 và tiềm năng phát triển dài hạn.',
    descriptionEn:
      'This award recognizes a male athlete under 18 with remarkable progress in 2025 and strong long-term development potential.',
    criteria: [
      { vi: 'Độ tuổi hợp lệ', en: 'Age eligibility' },
      { vi: 'Thành tích vượt lứa tuổi', en: 'Age-level achievements' },
      { vi: 'Tiềm năng chuyên môn', en: 'Technical potential' },
      { vi: 'Thái độ thi đấu', en: 'Training and competition attitude' },
    ],
  },
  {
    id: 'womens-u18-prospect',
    sectionId: 'professional',
    nameVi: 'VĐV Nữ Trẻ Triển Vọng Của Năm (U18)',
    nameEn: 'Women’s Young Prospect of the Year',
    descriptionVi:
      'Giải thưởng tôn vinh vận động viên nữ pickleball trẻ dưới 18 tuổi có bước tiến nổi bật và tiềm năng phát triển bền vững.',
    descriptionEn:
      'This award honors a female pickleball athlete under 18 who has shown significant improvement and strong long-term potential.',
    criteria: [
      { vi: 'Độ tuổi hợp lệ', en: 'Age eligibility' },
      { vi: 'Thành tích vượt lứa tuổi', en: 'Age-level achievements' },
      { vi: 'Tiềm năng chuyên môn', en: 'Technical potential' },
      { vi: 'Thái độ thi đấu', en: 'Training and competition attitude' },
    ],
  },
  {
    id: 'mens-40plus',
    sectionId: 'professional',
    nameVi: 'Nam Vận Động Viên Pickleball 40+ Xuất Sắc Nhất Của Năm',
    nameEn: 'Men’s Pickleball 40+ Player of the Year',
    descriptionVi:
      'Giải thưởng vinh danh vận động viên nam từ 40 tuổi trở lên có thành tích thi đấu nổi bật, duy trì phong độ bền bỉ, tinh thần thể thao tích cực và đóng vai trò truyền cảm hứng cho cộng đồng pickleball trung niên tại Việt Nam.',
    descriptionEn:
      'This award honors a male pickleball athlete aged 40 and above who demonstrates outstanding performance, longevity, sportsmanship, and inspirational community impact.',
    criteria: [
      { vi: 'Độ tuổi hợp lệ (40+)' },
      { vi: 'Thành tích thi đấu trong nhóm tuổi hoặc mở rộng' },
      { vi: 'Phong độ và khả năng duy trì thể lực' },
      { vi: 'Tinh thần thể thao và hình ảnh cá nhân' },
      { vi: 'Vai trò truyền cảm hứng cộng đồng' },
    ],
  },
  {
    id: 'womens-40plus',
    sectionId: 'professional',
    nameVi: 'Nữ Vận Động Viên Pickleball 40+ Xuất Sắc Nhất Của Năm',
    nameEn: 'Women’s Pickleball 40+ Player of the Year',
    descriptionVi:
      'Giải thưởng nhằm tôn vinh vận động viên nữ từ 40 tuổi trở lên có thành tích thi đấu đáng ghi nhận, duy trì đam mê, phong độ ổn định và góp phần lan tỏa tinh thần sống khỏe – tích cực thông qua pickleball.',
    descriptionEn:
      'This award recognizes a female pickleball athlete aged 40 and above with notable achievements, consistent performance, and positive advocacy for active lifestyles.',
    criteria: [
      { vi: 'Độ tuổi hợp lệ (40+)' },
      { vi: 'Thành tích thi đấu chính thức' },
      { vi: 'Phong độ và sự bền bỉ' },
      { vi: 'Hình ảnh tích cực & tinh thần thể thao' },
      { vi: 'Đóng góp cho cộng đồng người chơi trung niên' },
    ],
  },
  {
    id: 'pickleball-club-year',
    sectionId: 'community',
    nameVi: 'Câu Lạc Bộ Pickleball Hoạt Động Nổi Bật Của Năm',
    nameEn: 'Pickleball Club of the Year',
    descriptionVi:
      'Giải thưởng nhằm tôn vinh câu lạc bộ pickleball có hoạt động sôi nổi, tổ chức bài bản và vận hành bền vững, đóng vai trò trung tâm kết nối và phát triển cộng đồng pickleball tại địa phương và trên phạm vi rộng hơn. Giải thưởng ghi nhận năng lực tổ chức, khả năng duy trì phong trào, xây dựng cộng đồng người chơi ổn định, cũng như thành tích thi đấu và hình ảnh tích cực của các thành viên CLB.',
    descriptionEn:
      'This award recognizes a pickleball club with outstanding organizational activities, sustainable operations, and a central role in developing local and national pickleball communities. The award honors not only competitive results, but also community building, operational excellence, and positive club culture.',
    criteria: [
      { vi: 'Tần suất & quy mô hoạt động', en: 'Activity frequency & scale' },
      { vi: 'Đóng góp phong trào địa phương', en: 'Contribution to local development' },
      { vi: 'Số lượng thành viên & giải đấu tổ chức', en: 'Membership size & tournaments hosted' },
      { vi: 'Hình ảnh & uy tín CLB', en: 'Club image and reputation' },
    ],
  },
  {
    id: 'pickleball-tournament-year',
    sectionId: 'community',
    nameVi: 'Giải Thi Đấu Pickleball Của Năm',
    nameEn: 'Pickleball Tournament of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh giải đấu pickleball có chất lượng tổ chức xuất sắc, quy mô ấn tượng và sức lan tỏa mạnh mẽ trong nước và quốc tế, góp phần nâng tầm tiêu chuẩn thi đấu và hình ảnh pickleball Việt Nam. Giải thưởng đánh giá toàn diện từ quy mô, chuyên môn, trải nghiệm VĐV đến truyền thông và tác động cộng đồng.',
    descriptionEn:
      'This award honors a pickleball tournament with exceptional organizational quality, impressive scale, and strong national or international impact, contributing to elevating Vietnam’s competitive standards.',
    criteria: [
      { vi: 'Quy mô giải đấu', en: 'Tournament scale' },
      { vi: 'Công tác tổ chức & chuyên môn', en: 'Organization & technical standards' },
      { vi: 'Số lượng & chất lượng VĐV', en: 'Number & quality of athletes' },
      { vi: 'Truyền thông & độ phủ', en: 'Media exposure and community reach' },
    ],
  },
  {
    id: 'pickleball-venue-year',
    sectionId: 'community',
    nameVi: 'Cụm Sân Pickleball Của Năm',
    nameEn: 'Pickleball Venue of the Year',
    descriptionVi:
      'Giải thưởng nhằm tôn vinh cụm sân pickleball đạt tiêu chuẩn tổ chức các giải đấu quy mô lớn, chuyên nghiệp và tiệm cận chuẩn quốc tế, có khả năng đăng cai giải đấu cấp quốc gia – khu vực – quốc tế, đồng thời đóng vai trò hạ tầng chiến lược cho sự phát triển lâu dài của pickleball Việt Nam.',
    descriptionEn:
      'This award recognizes a pickleball venue capable of hosting large-scale, professional, and international-level tournaments, serving as a strategic infrastructure hub for long-term pickleball development.',
    criteria: [
      { vi: 'Chất lượng sân bãi & dịch vụ', en: 'Court quality & services' },
      { vi: 'Tần suất & hiệu suất hoạt động', en: 'Operational frequency' },
      { vi: 'Đóng góp cho cộng đồng', en: 'Contribution to players and ecosystem' },
    ],
  },
  {
    id: 'media-community-year',
    sectionId: 'community',
    nameVi: 'Cộng Đồng Truyền Thông Pickleball Của Năm',
    nameEn: 'Pickleball Media Community of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh cộng đồng truyền thông pickleball có vai trò lan tỏa thông tin chính xác, kiến thức giá trị và tinh thần thể thao tích cực, đồng thời kết nối cộng đồng người chơi một cách bền vững.',
    descriptionEn:
      'This award honors a media community that effectively spreads knowledge, positive values, and connects pickleball players through responsible and impactful communication.',
    criteria: [
      { vi: 'Quy mô & tương tác', en: 'Community size & engagement' },
      { vi: 'Nội dung tích cực, giá trị', en: 'Quality and positivity of content' },
      { vi: 'Ảnh hưởng cộng đồng', en: 'Community influence' },
    ],
  },
  {
    id: 'social-play-club-year',
    sectionId: 'community',
    nameVi: 'CLB Hoạt Động Social Play Của Năm',
    nameEn: 'Social Play Club of the Year',
    descriptionVi:
      'Giải thưởng tôn vinh CLB pickleball thúc đẩy mạnh mẽ phong trào social play, tạo môi trường chơi thân thiện, mở rộng cộng đồng người chơi mới và đề cao sức khỏe – kết nối – niềm vui.',
    descriptionEn:
      'This award recognizes a club that actively promotes social play, inclusivity, wellness, and community bonding, beyond competitive performance.',
    criteria: [
      { vi: 'Tần suất social play', en: 'Frequency of social play' },
      { vi: 'Mở rộng cộng đồng', en: 'Community growth' },
      { vi: 'Tính thân thiện & kết nối', en: 'Inclusiveness and friendliness' },
    ],
  },
  {
    id: 'content-creator-year',
    sectionId: 'community',
    nameVi: 'Nhà Sáng Tạo Nội Dung Pickleball Của Năm',
    nameEn: 'Pickleball Content Creator of the Year',
    descriptionVi:
      'Giải thưởng nhằm tôn vinh cá nhân hoặc đơn vị sáng tạo nội dung có đóng góp nổi bật trong việc định hình hình ảnh, kiến thức và cảm hứng pickleball Việt Nam trên các nền tảng truyền thông.',
    descriptionEn:
      'This award honors a content creator or organization that significantly contributes to shaping pickleball awareness, education, and inspiration.',
    criteria: [
      { vi: 'Chất lượng & sáng tạo', en: 'Content quality & creativity' },
      { vi: 'Tiếp cận & tương tác', en: 'Reach & engagement' },
      { vi: 'Đóng góp cộng đồng', en: 'Community contribution' },
    ],
  },
  {
    id: 'male-celebrity-advocate',
    sectionId: 'community',
    nameVi: 'Nam Nghệ Sĩ / Người Nổi Tiếng Hoạt Động Pickleball Nổi Bật Của Năm',
    nameEn: 'Male Celebrity Pickleball Advocate of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh nghệ sĩ hoặc người nổi tiếng có sức ảnh hưởng xã hội, tham gia pickleball nghiêm túc và bền bỉ, góp phần đưa pickleball đến công chúng đại chúng.',
    descriptionEn:
      'This award honors celebrities who actively and authentically participate in pickleball, using their influence to expand public awareness and community engagement.',
    criteria: [
      { vi: 'Mức độ tham gia', en: 'Level of participation' },
      { vi: 'Ảnh hưởng truyền thông', en: 'Media influence' },
      { vi: 'Lan tỏa phong trào', en: 'Positive advocacy' },
    ],
  },
  {
    id: 'female-celebrity-advocate',
    sectionId: 'community',
    nameVi: 'Nữ Nghệ Sĩ / Người Nổi Tiếng Hoạt Động Pickleball Nổi Bật Của Năm',
    nameEn: 'Female Celebrity Pickleball Advocate of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh nghệ sĩ hoặc người nổi tiếng có sức ảnh hưởng xã hội, tham gia pickleball nghiêm túc và bền bỉ, góp phần đưa pickleball đến công chúng đại chúng.',
    descriptionEn:
      'This award honors celebrities who actively and authentically participate in pickleball, using their influence to expand public awareness and community engagement.',
    criteria: [
      { vi: 'Mức độ tham gia', en: 'Level of participation' },
      { vi: 'Ảnh hưởng truyền thông', en: 'Media influence' },
      { vi: 'Lan tỏa phong trào', en: 'Positive advocacy' },
    ],
  },
  {
    id: 'brand-development-partner',
    sectionId: 'brand',
    nameVi: 'Thương Hiệu Đồng Hành Xây Dựng & Phát Triển Pickleball Của Năm',
    nameEn: 'Pickleball Development Partner of the Year',
    descriptionVi:
      'Giải thưởng nhằm vinh danh thương hiệu hoặc doanh nghiệp có đóng góp dài hạn, chiến lược và có chiều sâu, đồng hành phát triển hệ sinh thái pickleball Việt Nam.',
    descriptionEn:
      'This award recognizes a brand or corporation with long-term strategic commitment and meaningful impact on Vietnam’s pickleball ecosystem.',
    criteria: [
      { vi: 'Mức độ đầu tư & đồng hành', en: 'Level of investment & partnership' },
      { vi: 'Tính bền vững', en: 'Sustainability of commitment' },
      { vi: 'Tác động thực tế', en: 'Real ecosystem impact' },
    ],
  },
]

export const awardCategoryNames = awardCategories.map((row) => row.nameVi)

export const awardGroups = awardSections.map((section) => ({
  ...section,
  items: awardCategories.filter((row) => row.sectionId === section.id),
}))

export type { AwardCategory, AwardSection, AwardCriteria }
